<template>
    <PremiumFeatureGate required-subscription="premium" :value="value" :inline="inline" @input="$emit('input', $event)">
        <template slot="content">
            <p class="text-body-2 text--secondary mb-4 max-width-lg mx-auto premium-gate-content-intro">
                {{ $translate('warehousesPremiumIntro') }}
            </p>
            <ul class="premium-gate-bullets">
                <li>
                    <span class="premium-gate-bullet-icon">
                        <v-icon size="16" color="white">mdi-check</v-icon>
                    </span>
                    <span>{{ $translate('warehousesPremiumBullet1') }}</span>
                </li>
                <li>
                    <span class="premium-gate-bullet-icon">
                        <v-icon size="16" color="white">mdi-check</v-icon>
                    </span>
                    <span>{{ $translate('warehousesPremiumBullet2') }}</span>
                </li>
                <li>
                    <span class="premium-gate-bullet-icon">
                        <v-icon size="16" color="white">mdi-check</v-icon>
                    </span>
                    <span>{{ $translate('warehousesPremiumBullet3') }}</span>
                </li>
            </ul>
        </template>
    </PremiumFeatureGate>
</template>

<script>
import GlobalMixins from "@/mixins/global";
import PremiumFeatureGate from "@/components/common/premium-feature-gate";

export default {
    name: "PremiumFeatureGateWarehouses",
    mixins: [GlobalMixins],
    components: {
        PremiumFeatureGate,
    },
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        inline: {
            type: Boolean,
            default: true,
        },
    },
    i18n: {
        messages: {
            en: {
                warehousesPremiumIntro: "When stock is spread across several sites, it's hard to know what's where and to reconcile or plan. Safetee gives you one clear view per warehouse, fewer errors, and smoother deliveries and operations.",
                warehousesPremiumBullet1: "Create several warehouses to separate stock by site, building or activity.",
                warehousesPremiumBullet2: "Track stock levels and movements per warehouse for accurate inventory.",
                warehousesPremiumBullet3: "Configure delivery instructions and addresses per warehouse for smoother operations.",
            },
            fr: {
                warehousesPremiumIntro: "Quand le stock est réparti sur plusieurs sites, difficile de savoir ce qui est où, de rapprocher ou de planifier. Safetee vous donne une vision claire par entrepôt, moins d'erreurs et des livraisons et opérations plus fluides.",
                warehousesPremiumBullet1: "Créez plusieurs entrepôts pour séparer les stocks par site, bâtiment ou activité.",
                warehousesPremiumBullet2: "Suivez les niveaux et mouvements par entrepôt pour un inventaire fiable.",
                warehousesPremiumBullet3: "Configurez les instructions de livraison et adresses par entrepôt pour fluidifier les opérations.",
            },
        },
    },
};
</script>
